import classNames from 'classnames'

import { CardSection } from '@components/CardSection'

import styles from './styles.module.scss'

const MobileViewContainer = ({ cardSectionContent, buttonsSectionContent }) => (
    <div className={styles.loginContainerMobileView}>
        <CardSection className={classNames(styles.loginContainerTextSectionMobileView)}>
            {cardSectionContent}
        </CardSection>
        <div className={styles.buttonsContainer}>{buttonsSectionContent}</div>
    </div>
)

export default MobileViewContainer
